<template>
    <table class="table">
        <tr>
            <th>ID</th>
            <th></th>
            <th>Client id</th>
            <th>Name</th>
            <th>Alias</th>
            <th>Lang</th>
            <th>Type</th>
            <th></th>
        </tr>
        <tr v-for="item in items" :key="item.id">
            <td>
                <router-link v-if="item.clientId" :to="{ name: 'client-content-strings-edit', params: { clientId: item.clientId, contentId: item.id } }">{{item.id}}</router-link>
                <router-link
                    v-else
                    :to="{ name: 'system-content-strings-edit', params: { contentId: item.id } }"
                >{{item.id}}</router-link>
            </td>
            <td>
                <a v-clipboard:copy="item.id" class="button">
                    <span class="icon has-text-grey-light">
                        <i class="far fa-copy"></i>
                    </span>
                </a>
            </td>
            <td>{{item.clientId}}</td>
            <td>{{item.name}}</td>
            <td>{{item.alias}}</td>
            <td>{{item.language}}</td>
            <td>{{item.type}}</td>
            <td>
                <a class="button is-danger is-small" @click="deleteContent(item)">Delete</a>
            </td>
        </tr>
    </table>
</template>

<script>
import contentService from '../../../../services/content.service'

export default {
    name: 'content-string-list',
    props: {
        items: {
            type: Array,
            required: true
        },
        reload: {
            type: Function,
            required: true
        }
    },
    methods: {
        async deleteContent(content) {
            await contentService.deleteString(content.id);
            this.reload();
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/string/content-string-list.vue